import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestCallbackListService {

    constructor(private _http: HttpClient) { }

    getrequestcallback(data) {
        return this._http.post(environment.api_url+'admin/callbackrequest/list',data);
    }

}
